/* Parwin gallery: overlay arrows (shown only when there's more to scroll) + tag wide
   landscape images (ratio >= 1.5) so CSS can enlarge/overflow them on mobile. */
(function () {
  if (window.__parwinGallery) return; window.__parwinGallery = true;
  function enhance(g) {
    if (g.__pp) return; g.__pp = true;
    var wrap = document.createElement('div'); wrap.className = 'pp-gallery-wrap';
    g.parentNode.insertBefore(wrap, g); wrap.appendChild(g);
    var prev = document.createElement('button'); prev.type = 'button';
    prev.className = 'pp-gallery-arrow pp-gallery-arrow--prev'; prev.setAttribute('aria-label', 'Previous'); prev.innerHTML = '‹';
    var next = document.createElement('button'); next.type = 'button';
    next.className = 'pp-gallery-arrow pp-gallery-arrow--next'; next.setAttribute('aria-label', 'Next'); next.innerHTML = '›';
    wrap.appendChild(prev); wrap.appendChild(next);
    function step() { return Math.max(g.clientWidth * 0.9, 120); }
    prev.addEventListener('click', function () { g.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { g.scrollBy({ left: step(), behavior: 'smooth' }); });
    function upd() {
      var max = g.scrollWidth - g.clientWidth - 2;
      prev.hidden = g.scrollLeft <= 4;
      next.hidden = g.scrollLeft >= max;
    }
    // tag wide landscape images (the small-text infographics)
    g.querySelectorAll('img').forEach(function (im) {
      function check() {
        if (im.naturalWidth && im.naturalHeight) {
          if (im.naturalWidth / im.naturalHeight >= 1.5) im.classList.add('pp-wide');
          upd();
        }
      }
      if (im.complete) check(); else im.addEventListener('load', check);
    });
    g.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }
  function ready() { document.querySelectorAll('.pp-gallery').forEach(enhance); }
  if (document.readyState !== 'loading') ready(); else document.addEventListener('DOMContentLoaded', ready);
})();
